export default __webpack_public_path__ + "static/media/person_tab.eac6134d.png";